<template>
<div class="chapter">
<div class="inner_page">
<h3 class="h3"><a id="sec14"></a><span class="small">FROM</span> the <em>Mrs. Dalloway</em> series</h3>
<h4 class="h4"><a id="sec15"></a>Opened and Shut</h4>
<p class="poem">She had prepared a looking-glass: hair, dress, thought,<br/>sofa in the glow of dogs barking.</p>
<p class="poem">Beautifully close up. And once, flames<br/>eating the edge of the sofa.</p>
<p class="poem">Her eyelashes blurred. Chin, nose, forehead, some lips.<br/>The cheek. The glass looking first at one thing,<br/>then another: nose, eyes, evening.</p>
<p class="poem">She sat looking at the map of her hands.<br/>The window, the clock, her pulse.</p>
<p class="poem">The body was busy thinking, conjuring<br/>the museum of a moment: emotion, scenes, people,<br/>bags of treasures. Heaps of theories.</p>
<p class="poem"><a id="page_30"></a>Theories to explain feeling the here and the back of the hand.<br/>A theory allowed one thing after another.<br/>First, dinner, then morning.</p>
<p class="poem">Her hand was the world.<br/>To get to it she had to look at herself.</p>
<p class="poem">To get at the truth one would have to disregard<br/>anything false. Yet the truth was intangible.</p>
<p class="poem">One eye on the horizon: a long indeterminable,<br/>mere straightness, a few plants.<br/>That indescribable purple.</p>
<p class="poem">Doors being opened. Visual impressions—<br/>as if the eye were the brain, the body entering the house.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter1_i.vue?7a6a161c